import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Card from '../../components/elements/Card';
import ErrorHandler from '../../components/elements/ErrorHandler';
import { AppContext, ToastrContext } from '../../contexts';
import styles from './styles.scoped.css';
import FormByRegional from './FormByRegional';
import { fetchBaseGeneralPrices, submitSubUserProductPrices } from './actions';
import { Radio, Group } from '@mantine/core';
import { FormByRegistrationId } from './FormByRegistrationId';

export function Component() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryScope = searchParams.get('scope');
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const {
    messageProductPrices = '',
    dataSubmitSubUserProductPrices,
    isLoadingSubmitSubUserProductPrices,
    messageSubmitSubUserProductPrices,
    dataBaseGeneralPrices
  } = useSelector((s) => s.prices);
  const [scope, setScope] = useState(queryScope || '');

  useEffect(() => {
    dispatch(fetchBaseGeneralPrices());
  }, []);

  const radioData = [
    { label: 'Semua Data', value: 'byRegional' },
    { label: 'Pilih Subpangkalan Tertentu', value: 'byRegistrationId' },
  ];
  const radioStyles = {
    headingLabel: {
      label: {
        fontSize: '15px',
      },
    },
    elRadio: {
      label: {
        fontSize: '13px',
        fontWeight: 'normal',
      },
      inner: {
        display: 'flex',
        alignSelf: 'center',
      },
    },
  };
  const handleChangeScope = (value) => {
    setScope(value);
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('scope', value);
    navigate({
      pathname: location.pathname,
      search: newSearchParams.toString(),
    });
  };

  useEffect(() => {
    setBreadcrumbs([
      'Atur HET LPG 3 Kg',
      { name: 'Subpangkalan', to: '/price?tab=subpangkalan' },
      'Ubah Harga',
    ]);
  }, []);

  useEffect(() => {
    if (!isLoadingSubmitSubUserProductPrices && dataSubmitSubUserProductPrices) {
      setToastr({
        desc: 'Atur harga berhasil diubah',
        type: 'success',
        visible: true,
      });
      navigate(`/price?tab=subpangkalan`);
    } else if (!isLoadingSubmitSubUserProductPrices && messageSubmitSubUserProductPrices) {
      setToastr({
        desc: 'Atur harga gagal diubah',
        type: 'danger',
        visible: true,
      });
    }
  }, [
    dataSubmitSubUserProductPrices,
    isLoadingSubmitSubUserProductPrices,
    messageSubmitSubUserProductPrices,
  ]);

  if (messageProductPrices) {
    return <ErrorHandler message={messageProductPrices} />;
  }

  return (
    <div className={styles.form} style={{ width: '100%' }}>
      <Card className={styles.card}>
        {scope && (
          <>
            <Radio.Group
              label="Atur Harga"
              name="scope"
              onChange={handleChangeScope}
              styles={radioStyles.headingLabel}
              value={scope}
            >
              <Group mt="xs">
                {radioData.map((item, i) => (
                  <Radio
                    key={i}
                    label={item.label}
                    styles={radioStyles.elRadio}
                    value={item.value}
                  />
                ))}
              </Group>
            </Radio.Group>
            <hr className={styles.separator} style={{ margin: '1rem 0' }} />
          </>
        )}
        {scope !== 'byRegistrationId' ? (
          <FormByRegional
            onSubmit={(values) => dispatch(submitSubUserProductPrices(values))}
            productGeneralMaxPrice={dataBaseGeneralPrices?.productGeneralMaxPrice}
            productGeneralMinPrice={dataBaseGeneralPrices?.productGeneralMinPrice}
          />
        ) : (
          <FormByRegistrationId />
        )}
      </Card>
    </div>
  );
}

export default Component;
